var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import styles from './CreateProject.module.scss';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Button } from '@app/Components/Button/Button';
import { CreateProjectModal } from '@app/Widgets/CreateProjectModal/CreateProjectModal';
export var CreateProject = /** @class */ (function (_super) {
    __extends(CreateProject, _super);
    function CreateProject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._openCreateProjectModal = false;
        return _this;
    }
    CreateProject.prototype._toggleCreateProjectModal = function () {
        this._openCreateProjectModal = !this._openCreateProjectModal;
    };
    CreateProject.prototype._onSaveProject = function () {
        this._toggleCreateProjectModal();
    };
    CreateProject.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.action },
                React.createElement(Button, { color: "primary", onClick: this._toggleCreateProjectModal }, "Create Project")),
            this._openCreateProjectModal && (React.createElement(CreateProjectModal, { isOpen: this._openCreateProjectModal, onToggle: this._toggleCreateProjectModal, onSave: this._onSaveProject.bind(this) }))));
    };
    __decorate([
        observable
    ], CreateProject.prototype, "_openCreateProjectModal", void 0);
    __decorate([
        action.bound
    ], CreateProject.prototype, "_toggleCreateProjectModal", null);
    CreateProject = __decorate([
        observer
    ], CreateProject);
    return CreateProject;
}(React.PureComponent));
